import {Base} from "@/api/Base"

export class MpfSettingListAll extends Base {
    path = "mpfSetting/listAll"
}